<template>
  <div class="lesson-chunk-selector">
    <b-dropdown right :text="currentText" variant="light">
      <b-dropdown-item v-for="i in chunks" :key="i" @click="$emit('select', i)">
        Aulas {{ (i - 1) * 100 + 1 }} a {{ i * 100 }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  props: {
    current: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      chunks: Math.ceil(this.$user.cof.count_lessons / 100)
    };
  },
  computed: {
    currentText() {
      return `Aulas ${(this.current - 1) * 100 + 1} a ${this.current * 100}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.lesson-chunk-selector {
  ::v-deep button {
    background: #ffffff !important;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.05) !important;
    border-radius: 8px !important;
  }
}
</style>
